// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"52a6bbc7","554":"ea4cb49d","644":"8b32b7c8","667":"4840cffb","933":"0e56fdfc"}[chunkId] + ".chunk.js";
};